import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from '../services/alert.service';
import {EnvService} from '../services/env.service';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'micro-os-version-detail',
  templateUrl: './os-version-detail.component.html'
})
export class OsVersionDetailComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  @Input() osVersionId: any;
  @Output() persisted = new EventEmitter<any>();
  osVersion: any;
  osFamilyName: any = '';

  selectedOsFamily: any;

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient, private route: ActivatedRoute,
              private router: Router, private alertService: AlertService) {
  }

  ngOnInit(): void {
    if (this.osVersionId) {
      this.load(this.osVersionId);

    } else {
      this.route.params.subscribe((params: Params) => {
        params['id'] === '0' ? this.createNew() : this.load(params['id']);
      });
    }
  }

  load(id: string): void {
    this.http.get(`${this.env.e.url}/domain/cmdbOsVersions/${id}`).subscribe(data => {
      this.osVersion = data
      this.loadOSFamily(this.osVersion.osFamilyId);
    });
  }

  private loadOSFamily(osFamilyId?: string | null): void {
    // Check if the parameter is null or undefined
    if (!osFamilyId) return;

    this.http.get(`${this.env.e.url}/domain/cmdbOsFamily/${osFamilyId}`).subscribe({
        next: (osFamily: any) => {
          this.selectedOsFamily = osFamily;
          this.osFamilyName = osFamily ? osFamily.name : '';
          this.dataSource.data = [...this.dataSource.data];
        },
        error: () => {
          this.selectedOsFamily = undefined;
          this.osFamilyName = '';
          this.dataSource.data = [...this.dataSource.data];
        }
      });
  }

  createNew(): void {
    this.osVersion = {name: '', description: '', active: 'N', osFamily: '', companyId: this.auth.getCompanyId()};
  }

  save(): void {
    const isUpdate = !!this.osVersion.id;
    const request = isUpdate
      ? this.http.put(`${this.env.e.url}/domain/cmdbOsVersions/${this.osVersion.id}`, this.osVersion)
      : this.http.post(`${this.env.e.url}/domain/cmdbOsVersions`, this.osVersion);
    request.subscribe(data => {
      this.osVersion = data;
      this.alertService.info(`${isUpdate ? 'Updated' : 'Created'} ${this.osVersion.name}`);
      this.persisted.emit({data, action: isUpdate ? 'updated' : 'added'});
    });
  }

  delete(): void {
    this.http.delete(`${this.env.e.url}/domain/cmdbOsVersions/${this.osVersion.id}`).subscribe(() => {
      this.persisted.emit({data: this.osVersion, action: 'deleted'});
      this.alertService.info(`Deleted ${this.osVersion.name}`);
      if (!this.osVersionId) { this.router.navigate(['/osVersions']); }
    });
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.osVersion.active = target.checked ? 'Y' : 'N';
  }

  onOsFamilyChange(osFamily: any): void {
    this.selectedOsFamily = osFamily;
    this.osFamilyName = osFamily ? osFamily.name : '';
  }

}
